<template>
  <v-card v-model="EditTeamModel">
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <v-card class="ImgeUploader px-4" color="transparent" flat>
          <team-image-uploader-component
            @SetImage="SetImage"
            @SetImageFile="SetImageFile"
            :EditImage="EditTeamModel.ProfileImage"
          />
        </v-card>
        <v-container class="mt-4">
          <v-text-field
            v-model="form.firstName"
            label="First name"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.lastName"
            label="Last name"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.email"
            label="E-mail"
            required
            readonly
          ></v-text-field>
          <v-select
            :items="role"
            label="Role"
            item-text="Name"
            item-value="Id"
            single-line
            v-model="form.role"
          >
          </v-select>
          <v-select
            :items="status"
            label="Status"
            item-text="name"
            item-value="id"
            single-line
            v-model="form.status"
          >
          </v-select>
        </v-container>
      </v-form>
    </v-card>
    <div class="d-flex justify-end mx-5 py-7">
      <v-btn color="#A1A3A8" class="text_style mr-4" text @click="close(true)">
        Cancel
      </v-btn>
      <v-btn color="primary" depressed class="px-14 text_style" @click="send()">
        <span v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import TeamImageUploaderComponent from "./TeamImageUploader.component.vue";
export default {
  name: "editteamcomponent",
  props: ["EditTeamModel"],
  components: {
    // VueDropify,
    // vueDropzone: vue2Dropzone,
    TeamImageUploaderComponent,
  },

  data() {
    return {
      btnloader: false,
      valid: false,
      form: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        ProfileImage: null,
        ProfileImageFile: null,
        Role: {},
        status: {},
      },
      firstname: "",
      lastname: "",
      email: "",
      status: [
        { id: 2, name: "active" },
        { id: 3, name: "In-active" },
      ],
      password: "asdfadfasfasfasfa",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["Administrator	", "Viewer"],
      Role: null,
    };
  },
  watch: {},
  mounted() {
    var obj = Object.assign({}, this.EditTeamModel);
    this.form = {
      firstName: obj.FirstName,
      lastName: obj.LastName,
      email: obj.Email,
      role: {
        Id: obj.RoleId,
        Name: obj.Role,
      },
      status: obj.Status,
      id: obj.Id,
      ProfileImage: obj.ProfileImage,
    };

    this.fetchData();
  },

  methods: {
    async send() {
      var form = new FormData();
      form.append("Id", this.form.id);
      form.append("FirstName", this.form.firstName);
      form.append("LastName", this.form.lastName);
      form.append("Email", this.form.email);
      var Role = this.role.find((x) => x.Id == this.form.role);

      if (Role == undefined) {
        form.append("Role", this.form.role.Name);
        form.append("RoleId", this.form.role.Id);
      } else {
        form.append("Role", Role.Name);
        form.append("RoleId", Role.Id);
      }

      form.append("Status", this.form.status);

      form.append(
        "ProfileImage",
        this.EditTeamModel.ProfileImage != undefined
          ? this.EditTeamModel.ProfileImage
          : ""
      );
      form.append(
        "ProfileImageFile",
        this.form.ProfileImageFile != undefined
          ? this.form.ProfileImageFile
          : null
      );

      await this.$store.dispatch("EditTeamMember", form).then(() => {
        this.close();
        this.$router.push("/team");
      });
    },
    close(cancel) {
      this.$emit("close", cancel);
    },
    SetImage(Img) {
      this.form.ProfileImage = Img;
    },
    SetImageFile(Img) {
      this.form.ProfileImageFile = Img;
    },
    fetchData() {
      var obj = {
        page: 1,
        pageSize: "All",
      };
      this.$store.dispatch("GetRoles", obj).then((res) => {
        this.Role = res.roles[0];
        this.role = res.roles;
      });
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
.ImgeUploader {
  width: 11vw;
}
@media screen and (max-width: 430px) {
  .ImgeUploader {
    width: 100%;
  }
}
</style>
